import { useMemo } from 'react';

import { APP_ENVIRONMENT, CANONICAL_BASE } from '../const';

const NOINDEX_PATHS = ['/login', '/signup'];
const NOINDEX_PATTERNS = [/^\/advisor\/[^/]+\/[^/]+$/];

const isProduction = APP_ENVIRONMENT === 'production' || APP_ENVIRONMENT === 'prod';

const DEFAULT_TITLE = 'Veda AI by Astrology.com';
const DEFAULT_DESCRIPTION = "Veda AI by Astrology.com — The World's First AI Spiritual Guides!";

const META_MAP = {
    '/': {
        title: "Veda AI — The World's First AI Spiritual Guides",
        description:
            "Meet Veda's AI-powered spiritual advisors for personalized astrology, tarot, and spiritual guidance. Start a free conversation today."
    },
    '/catalog': {
        title: 'Advisor Catalog — Veda AI by Astrology.com',
        description: 'Browse our collection of AI spiritual advisors. Find the perfect guide for astrology, tarot, numerology, and more.'
    },
    // HORO-10703: indexable on purpose — a pricing page is something people
    // search for by name, and it is the one Veda surface with no account, no
    // personalisation and nothing behind a login.
    '/plans': {
        title: 'Plans & Pricing — Veda AI by Astrology.com',
        description:
            'Compare the Veda AI Free and Premium plans. Unlimited messages, every advisor, tarot readings and your full birth chart from $4.99 a month.'
    },
    '/activities': {
        title: 'Activities — Veda AI by Astrology.com',
        description:
            'Explore spiritual activities and guided experiences with Veda AI. Discover tarot readings, birth chart analysis, and more.'
    }
};

const getCanonicalUrl = (pathname) => {
    return pathname === '/' ? CANONICAL_BASE : `${CANONICAL_BASE}${pathname}`;
};

const useSeoTags = (pathname) => {
    return useMemo(() => {
        const canonicalUrl = getCanonicalUrl(pathname);
        const isNoIndexPath = NOINDEX_PATHS.includes(pathname) || NOINDEX_PATTERNS.some((re) => re.test(pathname));
        const meta = META_MAP[pathname];

        return {
            canonical: isNoIndexPath ? null : canonicalUrl,
            robots: !isProduction || isNoIndexPath ? 'noindex, nofollow' : null,
            title: meta?.title || DEFAULT_TITLE,
            description: meta?.description || DEFAULT_DESCRIPTION
        };
    }, [pathname]);
};

export default useSeoTags;
